// @flow

// Action Types
export const prefix = '@@datatable'

export const PAGINATE = 'PAGINATE'
export const SELECT = 'SELECT'
export const SELECT_ALL = 'SELECT_ALL'
export const FILTER = 'FILTER'
export const SORT = 'SORT'
export const GROUP = 'GROUP'
export const ORDER = 'ORDER'
export const RESET_DATA_TABLE_STATE = 'RESET_DATA_TABLE_STATE'

// Sort by
export const ASC = 'asc'
export const DESC = 'desc'

// Sort as
export const SORT_AS_DATE = 'SORT_AS_DATE'
export const SORT_AS_MIX = 'SORT_AS_MIX'
export const SORT_AS_NUMBER = 'SORT_AS_NUMBER'
export const SORT_AS_BOOLEAN = 'SORT_AS_BOOLEAN'
export const SORT_AS_GROUP = 'SORT_AS_GROUP'
export const SORT_AS_STRING = 'SORT_AS_STRING'

// Column size
export const SMALL_SIZE = 'SMALL_SIZE'
export const MEDIUM_SIZE = 'MEDIUM_SIZE'
export const LARGE_SIZE = 'LARGE_SIZE'
export const AVAILABLE_SIZES_ARR = [SMALL_SIZE, MEDIUM_SIZE, LARGE_SIZE]
export const SIZE_CONFIG = {
  [SMALL_SIZE]: 1,
  [MEDIUM_SIZE]: 1.5,
  [LARGE_SIZE]: 2,
}
